import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { FilterRealSeason } from '../classes/filterRealSeason';

@Injectable({
  providedIn: 'root'
})
export class RealSeasonService extends BaseService {

  constructor(http: HttpClient) {
    super(http);
    this.entity = 'season';
  }
  private filterObs$: BehaviorSubject<FilterRealSeason> = new BehaviorSubject(new FilterRealSeason());
    getFilterObs(): Observable<FilterRealSeason> {
        return this.filterObs$.asObservable();
    }
    setFilterObs(filter: FilterRealSeason) {
          this.filterObs$.next(filter);
    }
}
